import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API, auth, errMsg } from '../finance/shared';
import Icon from '../../../components/dashboard/DashboardIcons';

const CONFIRM_PHRASE = 'حذف جميع اللاعبين';

export default function DangerZoneDeleteAllModal({ onClose, onDeleted }) {
  const [count, setCount] = useState(null);
  const [loadingCount, setLoadingCount] = useState(true);
  const [confirmText, setConfirmText] = useState('');
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState(null);

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    axios.get(`${API}/players/danger-zone/counts`, auth())
      .then((res) => setCount(res.data?.players_count ?? 0))
      .catch(() => setCount(null))
      .finally(() => setLoadingCount(false));
    return () => { document.body.style.overflow = ''; };
  }, []);

  const canConfirm = confirmText.trim() === CONFIRM_PHRASE && !busy && !loadingCount;

  const submit = async () => {
    if (!canConfirm) return;
    setBusy(true); setErr(null);
    try {
      await axios.post(`${API}/players/danger-zone/delete-all`, { confirmation: confirmText.trim() }, auth());
      onDeleted?.();
    } catch (e) {
      setErr(errMsg(e, 'فشل الحذف'));
      setBusy(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-end justify-center bg-black/60 p-0 sm:items-center sm:p-4" data-testid="danger-zone-delete-all-modal">
      <div className="max-h-[92vh] w-full max-w-md overflow-y-auto rounded-t-2xl bg-white shadow-2xl sm:rounded-2xl">
        <div className="flex items-center gap-3 border-b border-red-100 bg-red-50 px-5 py-4">
          <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-red-100 text-red-600">
            <Icon name="warning" className="h-5 w-5" />
          </div>
          <h3 className="text-base font-bold text-red-700">حذف جميع اللاعبين والاشتراكات</h3>
        </div>

        <div className="space-y-4 px-5 py-5">
          {loadingCount ? (
            <div className="h-16 animate-pulse rounded-lg bg-slate-100" />
          ) : (
            <div className="rounded-lg bg-slate-50 px-4 py-3 text-sm text-slate-700" data-testid="danger-zone-players-count">
              سيتم حذف <span className="font-bold text-red-700">{count ?? '—'}</span> لاعب نهائياً من منشأتك.
            </div>
          )}

          <div className="rounded-lg border border-red-200 bg-red-50 px-4 py-3 text-sm font-semibold text-red-700" data-testid="danger-zone-warning">
            تحذير: سيتم حذف جميع اللاعبين والاشتراكات والبيانات المرتبطة بهم (الدفعات، الحضور، الأهداف، البطاقات، روابط أولياء الأمور) نهائيًا ولا يمكن التراجع.
          </div>

          <div>
            <label className="mb-1.5 block text-sm font-semibold text-slate-700">
              اكتب <span className="font-bold text-red-700" dir="rtl">«{CONFIRM_PHRASE}»</span> لتفعيل الحذف
            </label>
            <input
              dir="rtl"
              value={confirmText}
              onChange={(e) => setConfirmText(e.target.value)}
              placeholder={CONFIRM_PHRASE}
              className="w-full rounded-lg border border-slate-300 px-3 py-2.5 text-sm outline-none focus:border-red-400"
              data-testid="danger-zone-confirm-input"
            />
          </div>

          {err && <div className="rounded-lg bg-red-50 px-3 py-2 text-sm text-red-700" data-testid="danger-zone-error">{err}</div>}

          <div className="flex justify-end gap-2 pt-1">
            <button type="button" onClick={onClose} disabled={busy} className="rounded-lg border border-slate-200 px-4 py-2 text-sm text-slate-600" data-testid="danger-zone-cancel-btn">إلغاء</button>
            <button
              type="button"
              onClick={submit}
              disabled={!canConfirm}
              className="rounded-lg bg-red-600 px-4 py-2 text-sm font-bold text-white disabled:cursor-not-allowed disabled:opacity-40"
              data-testid="danger-zone-confirm-btn"
            >
              {busy ? 'جارٍ الحذف...' : 'حذف نهائي'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
